import moment from 'moment-timezone';
import Request from 'files/Request.js';

class Instruction {

    active = null;
    category = null;
    description = null;
    date = null;
    id = null;
    in_use = null;
    metadata = null;
    name = null;
    preferences = null;
    user_id = null;

    create = (props = {}) => {
        this.active = props.active;
        this.category = props.category;
        this.date = props.date && moment.utc(props.date).local();
        this.description = props.description;
        this.id = props.id;
        this.in_use = props.in_use;
        this.metadata = props.metadata;
        this.name = props.name;
        this.preferences = props.preferences;
        this.user_id = props.user_id;
        return this;
    }
}

const categories = {
    accounts: 1,
    devices: 2,
    system_triggers: 3,
    blueprints: 4
}

export const fetchInstruction = async (utils, id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { trigger_instruction } = await Request.get(utils, '/users/', {
                id: id,
                type: 'trigger_instruction_details'
            });
            resolve(new Instruction().create(trigger_instruction));
        } catch(e){
            reject(e);
        }
    });
}

export default {
    categories: {
        get: () => categories
    },
    create: props => new Instruction().create(props),
    get: fetchInstruction,
    new: () => new Instruction()
}